import classnames from 'classnames';
import { MdiReactIconComponentType } from 'mdi-react';
import { ReactElement, FC, MouseEvent } from 'react';

import styles from './Pill.module.scss';

interface Props {
  icon?: MdiReactIconComponentType | ReactElement;
  iconPosition?: 'left' | 'right';
  id: string;
  onClick: (event: MouseEvent<HTMLDivElement>, id: string) => void;
  selected?: boolean;
  text?: string;
}

const Pill: FC<Props> = ({
  id,
  icon,
  iconPosition = 'left',
  selected = false,
  text,
  onClick = () => undefined,
}) => (
  <div
    className={classnames(styles['pill-container'], {
      [styles['selected']]: selected,
    })}
    onClick={(event: MouseEvent<HTMLDivElement>) => onClick(event, id)}
    tabIndex={0}
    role="button"
  >
    {Boolean(icon) && iconPosition === 'left' && icon}
    {text}
    {Boolean(icon) && iconPosition === 'right' && icon}
  </div>
);

export type { Props as PillProps };
export default Pill;
